import PropTypes from 'prop-types';

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import accessDenied from '../../../images/unused-undraw-illustrations/undraw_access_denied_re_awnf.svg';

const defaultCardStyle = {
  width: '500px',
  margin: 'auto',
  maxWidth: '90vw',
};
const imageContainer = {
  width: 200,
  display: 'block',
  margin: 'auto',
  marginBottom: '1rem',
};

const NotInvitedCardComponent = ({ selectedBarn = { name: 'Your barn' } }) => (
  <Box sx={{ mt: 2 }}>
    <Card style={defaultCardStyle}>
      <CardHeader
        title={`No Access to ${selectedBarn.name}`}
        subheader={(
          <Typography gutterBottom sx={{ fontWeight: 300 }}>
            {selectedBarn.name} has not invited you to join their Questri organization yet.
          </Typography>
        )}
      />
      <CardContent>
        <img src={accessDenied} alt="man access denied app" style={imageContainer} />
        <Alert severity="warning" sx={{ mb: 2 }}>
          You need to be invited to the Questri organization before you can log in and access it.
        </Alert>

        <Typography variant="caption" component="div" align="center" gutterBottom>
          If you feel this is a mistake, please
          contact an admin for this Questri organization.
        </Typography>
      </CardContent>
    </Card>
  </Box>
);

NotInvitedCardComponent.propTypes = { selectedBarn: PropTypes.object };

NotInvitedCardComponent.defaultProps = { selectedBarn: { name: 'Your barn' } };

export default NotInvitedCardComponent;
